import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { SidebarStore } from '@macs-frontend/core/store/sidebar.store';
import { environment } from '@macs-frontend/env';
import { CurrentCompanyService } from '@macs-frontend/web-macs/core';
import { ModuleNames } from '@macs-frontend/web-macs/shared/enums/module-names';
import { Observable } from 'rxjs';
import { BaseCompany } from '../../models/company.model';
import { makeSelectable, SelectSubscribe } from '@macs-frontend/decorators';
import { defaultUserPermissions, getUserPermissions } from '@macs-frontend/reducers/meta';
import { BaseComponent } from '@macs-frontend/core';
import { Store } from '@ngrx/store';

@Component({
  /* eslint-disable-next-line @angular-eslint/component-selector */
  selector: 'cc-left-sidebar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './left-sidebar.component.html',
})
export class LeftSidebarComponent extends BaseComponent {
  // @ts-expect-error
  @Input() module: ModuleNames;
  @Input() userCompanies: BaseCompany[] = [];

  @Output() toggleSidebar: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  showCompanySwithcerHandler: EventEmitter<void> = new EventEmitter<void>();
  currentCompany$: Observable<BaseCompany>;

  imagesPath = environment.images_path;

  ModuleNames = ModuleNames;

  @SelectSubscribe(getUserPermissions)
  userPermissions = defaultUserPermissions;

  handleSidebarIconClick() {
    this.toggleSidebar.emit();
  }

  switchModule() {
    this.router.navigate([{ outlets: { modal: 'modules' } }]);
  }

  showCompanySwithcer() {
    this.showCompanySwithcerHandler.emit();
  }

  constructor(
    private router: Router,
    currentCompanyService: CurrentCompanyService,
    readonly sidebarStore: SidebarStore,
    readonly cdr: ChangeDetectorRef,
    readonly store$: Store<any>,
  ) {
    super();
    this.currentCompany$ = currentCompanyService.currentCompany$;
    makeSelectable(this, { cdr, store$ });
  }
}
